"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagLabelBox = exports.TagLabel = void 0;

require("./TagLabelBox.css");

var _react = _interopRequireWildcard(require("react"));

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
    Tag labels
    
    A simple box that returns multiple tag labels.
    You can also only use the tag itself

    Verified by: Yorben Verhoest
    Date: 04/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Component that returns multiple labels together
var TagLabelBox = function TagLabelBox(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tagLabelBox"
  }, props.labels && props.labels.map(function (label, index) {
    return label.name && /*#__PURE__*/_react["default"].createElement(TagLabel, {
      color: label.color,
      index: index,
      key: index,
      labels: props.labels,
      name: label.name,
      onClick: label.onClick,
      onClose: label.onClose ? function (e) {
        return label.onClose(e);
      } : undefined
    });
  }));
}; // Component that returns a single label


exports.TagLabelBox = TagLabelBox;

var TagLabel = function TagLabel(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tagLabel ".concat(props.onClose ? 'close' : ''),
    style: {
      backgroundColor: "var(--".concat(props.color ? props.color : 'sub', ")"),
      boxShadow: "5px 5px 20px -5px var(--".concat(props.color ? props.color : 'sub', ")")
    },
    title: props.name && typeof props.name === 'string' ? props.name : ''
  }, /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return props.onClick ? props.onClick(props) : undefined;
    }
  }, props.name ? props.name : 'Label'), props.onClose && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "CloseCircle",
    onClick: function onClick() {
      props.onClose; // const label_copy = props.labels
      // label_copy.splice(props.index, 1)
      // props.onClose(label_copy)
    }
  }));
};

exports.TagLabel = TagLabel;